YP.StoreManager = function() {
    var overlay = null;
    var overlayInfo = null;
    var packForm = null;
    var theBody = null;
    return {
        init: function() {
            // events
            this.overlay = $('.overlay-pay');
            this.overlayInfo = $('.overlay-pay-info');
            this.packForm = $('.feature-pack form');
            this.theBody = $('body');
            this.overlay.click({
                klass: this
            }, this.hideOverlay);
            this.packForm.submit({
                klass: this
            }, this.showOverlay);
            if($('.form_bc').length) {
                this.initPaymentCbForm();
            }
            this.initSelectCbForm();
            this.initSelectActivationForm();
            this.initSelectSubTypeForm();
            this.initValidateCodePromoLink();
        },
        hideOverlay: function(e) {
            $(this).fadeOut();
            e.data.klass.overlayInfo.fadeOut(function() {
                $(this).html('<i class="icon-3x icon-spinner icon-spin"></i>');
            });
        },
        showOverlay: function(e) {
            var klass = e.data.klass;
            klass.overlay.fadeIn();
            klass.overlayInfo.show();
            klass.theBody.animate({
                scrollTop: 0
            }, '750');
            var el = $(this);
            $.post(el.attr('action'), {
                unlockFeatures: $('.unlockFeatures', el).val()
            }, function(data) {
                klass.overlayInfo.hide().html(data).fadeIn();
            });
            e.preventDefault();
        },
        initPaymentCbForm: function() {
            $('form.cb-payment-form, form.payment_offre').submit(function(){
                var $newCbModal = $('.js-add-new-cb');
                var theForm = this;
                var useHostedField = true;
                if($newCbModal.length) {
                    var oldValue = $newCbModal.find("button:submit").html();
                    $newCbModal.find("button:submit").attr('disabled', 'disabled');
                    $newCbModal.find("button:submit").html('<i class="fa fa-spinner fa-spin fa-lg"></i>');
                } else {
                    if($('.information_bc .block_choice.active').data('id') != 0) {
                        useHostedField = false;
                    }
                }

                if(useHostedField) {
                    hfields.createToken(function (result) {
                        if (result.execCode == '0000') {
                            if($newCbModal.length){
                                // NEw CB
                                $('#payment_hf_token').val(result.hfToken);
                                $('#payment_card_code').val(result.cardCode);
                                $('#payment_card_expiry_date').val(result.cardValidityDate);
                                $('#payment_card_type').val(result.cardType);
                                $('#payment_card_selected_brand').val(result.selectedBrand);
                            }else {
                                // STORE
                                $('#account_asso_payment_new_credit_card_hf_token').val(result.hfToken);
                                $('#account_asso_payment_new_credit_card_card_code').val(result.cardCode);
                                $('#account_asso_payment_new_credit_card_card_expiry_date').val(result.cardValidityDate);
                                $('#account_asso_payment_new_credit_card_card_type').val(result.cardType);
                                $('#account_asso_payment_new_credit_card_card_selected_brand').val(result.selectedBrand);
                            }

                            theForm.submit();
                            YP.ModalManager().closeModal();
                            return true;
                        }else {
                            if($newCbModal.length){
                                $newCbModal.find("button:submit").html(oldValue);
                                $newCbModal.find("button:submit").removeAttr('disabled');
                            }
                        }
                    });
                    return false;
                }else {
                    // Use already registered CB in store. 
                    theForm.submit();
                    YP.ModalManager().closeModal();
                    return true;
                }
            });

            var style = {
                "input": {
                    "font-size": "14px",
                    "color": "#555"
                }
            };
            var hfields = dalenys.hostedFields({
                // Use your Public API Key
                key: {
                    id: $('.form_bc').data('api-key-id'),
                    value: $('.form_bc').data('api-key')
                },
                // Link and configure each hosted input field by providing the corresponding container ID
                fields: {
                    'brand': {
                        id: 'brand-container',
                        version: 2,
                        useInlineSelection: true,
                        isCbPreferredNetwork: true,
                    },
                    'card': {
                        id: 'card-container',
                        style: style
                    },
                    'expiry': {
                        id: 'expiry-container',
                        style: style

                    },
                    'cryptogram': {
                        id: 'cvv-container',
                        style: style,
                        onFocus: function(e){
                            $('.ccv-info').show()
                        },
                        onBlur: function(e){
                            $('.ccv-info').hide();
                        }

                    }
                }
            });
            hfields.load();
        },
        initSelectCbForm: function() {
            $('.information_bc .block_choice').on('click', function(e){
                e.preventDefault();
                $('#account_asso_payment_credit_card').val($(this).data('id'));
            });
        },
        updateFeatureCount: function(type, count) {
            switch (type) {
                case 2:
                    $('.newsletter-mail-count').html(count);
                    break;
            }
        },
        initSelectActivationForm: function() {
            $('.block_choice_month_year').on('click', function(e) {
                value = $(this).data('val');
                $('#subscription_type_input').val(value);
            });
            $('.block_choice_subscription_type').on('click', function(e) {
                value = $(this).data('val');
                $('#subscription_activation_input').val(value);
            });
        },
        initSelectSubTypeForm: function() {
            $('table.subscription_type a').on('click', function(e) {
                e.preventDefault();
                $('table.subscription_type div').removeClass('success');
                $('table.subscription_type i').attr('class', 'fa fa-square-o');
                $(this).parent().addClass('success');
                $(this).parent().find('i').attr('class', 'fa fa-check-square-o');
                value = $(this).data('val');
                $('#account_asso_payment_subscription_type').val(value);
                $.ajax({
                    url: constructUrl('store/changeSubscriptionType'),
                    type: 'GET',
                    data: {
                        account_type_id: $('#account_asso_payment_account_type_id').val(),
                        subscription_type: $('#account_asso_payment_subscription_type').val(),
                        code: $('input#code').val()
                    },
                    success: function(data) {
                        $('table.subscription_pricing').html(data);
                    }
                });
            });
        },
        initValidateCodePromoLink: function() {
            $('#code_promo').keypress(function(e){
                if (e.keyCode === 13) {
                    e.preventDefault();
                    $('#promo-form').trigger('click');
                }
            });
            $('#promo-form').on('click', function(e){
                e.preventDefault();

                link = $(this).data('url');
                code = $('.code_promo_input').val();

                $.ajax({
                    url: link,
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        code: code
                    },
                    success: function(data) {
                        if(data.errorCode) {
                            $('.promo-error').show();
                            $('.promo-container').addClass('show_error');
                            $('.promo-valid').hide();
                            $('.promo-container').removeClass('show_success');

                            $('.promo-valid').html('');
                            $('.block_choice_month_year .month .price').html($('.month .price').data('price') + '€');
                            $('.block_choice_month_year .year .price').html($('.year .price').data('price') + '€');
                            $('.block_choice_month_year .month .text_2 s').html('');
                            $('.block_choice_month_year .year .text_2 s').html('');
                            $('#account_asso_payment_promo_code').val('');

                        } else if(data.validCode) {
                            $('.promo-valid').show();
                            $('.promo-container').addClass('show_success');
                            $('.promo-error').hide();
                            $('.promo-container').removeClass('show_error');

                            $('.promo-valid').html(data.promoLabel);
                            $('.block_choice_month_year .month .price').html(data.newPriceByMonth + '€');
                            $('.block_choice_month_year .year .price').html(data.newPriceByYear + '€');
                            $('.block_choice_month_year .month .text_2 s').html($('.month .price').data('price') + '€');
                            $('.block_choice_month_year .year .text_2 s').html($('.year .price').data('price') + '€');
                            $('#account_asso_payment_promo_code').val(data.code);


                        } else {
                            $('.promo-error').hide();
                            $('.promo-container').removeClass('show_error');
                            $('.promo-valid').hide();
                            $('.promo-container').removeClass('show_success');

                            $('.promo-valid').html('');
                            $('.block_choice_month_year .month .price').html($('.month .price').data('price') + '€');
                            $('.block_choice_month_year .year .price').html($('.year .price').data('price') + '€');
                            $('.block_choice_month_year .month .text_2 s').html('');
                            $('.block_choice_month_year .year .text_2 s').html('');
                            $('#account_asso_payment_promo_code').val('');

                        }
                    }
                });
            });
        }
    };
};
window.addEventListener("load", function() {
    YP.StoreManager().init();
});
